import React, { Component } from "react";
import $ from "jquery";
import { ToastContainer, toast } from "react-toastify";
class ColorPlatte extends Component {
  constructor(props) {
    super(props);

    this.settings = { effect: "Zoom", duration: 400, delay: 0 };
    this.state = {
      color: "#FFAA00",
      defaultWidgetskinType: "CLASSIC",
      widgetSkinType: "CLASSIC",
      widgetSkinTypes: {},
    };
    this.previewSkins = ["CLASSIC"];
  }
  notifyChangeColorUpdatedSuccess(propertyName) {
    toast.dismiss();
    toast(
      <b>
        <img
          src="assets/images/done.svg"
          style={{ paddingRight: "0px" }}
          content=""
        />
        &nbsp;&nbsp;{propertyName} saved successfully
      </b>,
      {
        position: "top-center",
      }
    );
  }
  notifyFailToSave(falseRes) {
    toast.dismiss();
    toast(<b style={{ color: "red" }}>{falseRes}</b>, {
      position: "top-center",
      color: "red",
    });
  }
  refreshColor = (e) => {
    this.fetchColorApi();
    this.fetchWidgetSkin();
    this.fetchWidgetSkintypesApi();
    var colorPaletteController = this;
    if (
      document.getElementById("heading") != null &&
      document.getElementById("firstScreenbtn") != null
    ) {
      var widgetColorTimer = setInterval(function () {
        clearTimeout(widgetColorTimer);
        document.getElementById("heading").style.background =
          colorPaletteController.state.color;
        document.getElementById("firstScreenbtn").style.background =
          colorPaletteController.state.color;
      }, 50);
    }
  };

  getProjectId = (projectId) => {
    if (!projectId) {
      projectId = this.projectId;
      if (!projectId) {
        projectId = localStorage.getItem("currentProjectId");
      }
    }

    return projectId;
  };

  fetchWidgetSkintypesApi = (projcetId) => {
    projcetId = this.getProjectId(projcetId);
    var widgetColorController = this;
    $.ajax({
      url: "/api/fetch-widget-skin-types",
      async: false,
      method: "GET",
      headers: {
        Authorization: "Bearer " + localStorage.getItem("access_token"),
      },
      data: {
        projectId: projcetId,
      },
      success: function (res) {
        if (res.success === true) {
          var skinTypes = res.result;
          console.log(skinTypes);
          widgetColorController.setState({ widgetSkinTypes: skinTypes });
        }
      },
      error: function (xhr) {
        if (xhr.status == 401) {
          window.location.href = "/";
        }
      },
    });
  };

  handleSkinChange = (skin) => {
    console.log(this.props);
    console.log(skin);
    this.props.handleSkinChange(this.previewSkins.includes(skin));
  };

  saveData = (e) => {
    this.saveColorApi(e);
    this.saveSkinTypeApi(e);
    this.handleSkinChange(this.state.widgetSkinType);
  };

  saveColorApi = (e) => {
    var colorPaletteController = this;
    if (
      colorPaletteController.validColorCode(colorPaletteController.state.color)
    ) {
      var formData = {
        projectId: localStorage.getItem("currentProjectId"),
        agentPropertyName: "THEME_COLOR",
        agentPropertyValue: document.getElementById("hexinput").value,
      };

      $.ajax({
        url: "/api/agent-properties",
        async: false,
        method: "POST",
        headers: {
          Authorization: "Bearer " + localStorage.getItem("access_token"),
          "Content-Type": "application/json",
        },
        data: JSON.stringify(formData),
        processData: false,
        contentType: "application/json; charset=UTF-8",
        success: function (res) {
          if (res.success === true) {
            colorPaletteController.notifyChangeColorUpdatedSuccess(
              formData.agentPropertyValue + " color"
            );
          } else {
            colorPaletteController.notifyFailToSave(res.result);
          }
        },
        error: function (xhr) {
          if (xhr.status == 401) {
            window.location.href = "/";
          }
        },
      });
    } else {
      colorPaletteController.notifyInvalidColorCode();
    }
  };

  saveSkinTypeApi = (e) => {
    var colorPaletteController = this;

    var formData = {
      projectId: localStorage.getItem("currentProjectId"),
      agentPropertyName: "WIDGET_SKIN",
      agentPropertyValue: this.state.widgetSkinType,
    };

    $.ajax({
      url: "/api/agent-properties",
      async: false,
      method: "POST",
      headers: {
        Authorization: "Bearer " + localStorage.getItem("access_token"),
        "Content-Type": "application/json",
      },
      data: JSON.stringify(formData),
      processData: false,
      contentType: "application/json; charset=UTF-8",
      success: function (res) {
        if (res.success === true) {
          colorPaletteController.notifyChangeColorUpdatedSuccess(
            formData.agentPropertyValue + " skin"
          );
        } else {
          colorPaletteController.notifyFailToSave(res.result);
        }
      },
      error: function (xhr) {
        if (xhr.status == 401) {
          window.location.href = "/";
        }
      },
    });
  };

  fetchWidgetSkin = (projectId) => {
    projectId = this.getProjectId(projectId);
    var widgetColorController = this;
    $.ajax({
      url: "/api/agent-property",
      async: false,
      method: "GET",
      headers: {
        Authorization: "Bearer " + localStorage.getItem("access_token"),
      },
      data: {
        projectId: projectId,
        agentPropertyName: "WIDGET_SKIN",
      },
      success: function (res) {
        if (res.success === true) {
          if (res.result != null) {
            var skintype = res.result["agentPropertyValue"];
            if (skintype != "") {
              widgetColorController.setState({ widgetSkinType: skintype });
              widgetColorController.handleSkinChange(skintype);
            } else {
              widgetColorController.setState({
                widgetSkinType:
                  widgetColorController.state.defaultWidgetskinType,
              });
            }
          }
        } else {
          widgetColorController.setState({
            widgetSkinType: widgetColorController.state.defaultWidgetskinType,
          });
        }
      },
      error: function (xhr) {
        if (xhr.status == 401) {
          window.location.href = "/";
        }
      },
    });
  };
  fetchColorApi(projectId) {
    if (!projectId) {
      projectId = this.projectId;
      if (!projectId) {
        projectId = localStorage.getItem("currentProjectId");
      }
    }
    var widgetColorController = this;
    $.ajax({
      url: "/api/agent-property",
      async: false,
      method: "GET",
      headers: {
        Authorization: "Bearer " + localStorage.getItem("access_token"),
      },
      data: {
        projectId: projectId,
        agentPropertyName: "THEME_COLOR",
      },
      success: function (res) {
        if (res.success === true) {
          if (res.result != null) {
            var themeColor = res.result["agentPropertyValue"];
            if (themeColor != "") {
              widgetColorController.setState({ color: themeColor });
              if (document.getElementById("hexinput") != null) {
                document.getElementById("hexinput").value = themeColor;
              }
            } else {
              widgetColorController.setState({ color: "#FFAA00" });
            }
          }
        } else {
          widgetColorController.setState({ color: "#FFAA00" });
        }
      },
      error: function (xhr) {
        if (xhr.status == 401) {
          window.location.href = "/";
        }
      },
    });
  }

  componentDidMount() {
    var thisController = this;
    setTimeout(() => {
      this.fetchColorApi();
      this.fetchWidgetSkin();
      this.fetchWidgetSkintypesApi();
    }, 300);
    document.addEventListener("projectChanged", function (event) {
      thisController.projectId = event.projectId;
      thisController.fetchColorApi(event.projectId);
      this.fetchWidgetSkin(event.projectId);
      thisController.fetchWidgetSkintypesApi(event.projectId);
    });

    (function () {
      $(
        ".red1,.red2,.red3,.red4,.red5,.red6,.red7,.red8,.red9,.red10,.red11,.red12,.red13,.red14,\
.pink1,.pink2,.pink3,.pink4,.pink5,.pink6,.pink7,.pink8,.pink9,.pink10,.pink11,.pink12,.pink13,.pink14,\
.purple1,.purple2,.purple3,.purple4,.purple5,.purple6,.purple7,.purple8,.purple9,.purple10,.purple11,.purple12,.purple13,.purple14,\
.deep-purple1,.deep-purple2,.deep-purple3,.deep-purple4,.deep-purple5,.deep-purple6,.deep-purple7,.deep-purple8,.deep-purple9,.deep-purple10,.deep-purple11,.deep-purple12,.deep-purple13,.deep-purple14,\
.indigo1,.indigo2,.indigo3,.indigo4,.indigo5,.indigo6,.indigo7,.indigo8,.indigo9,.indigo10,.indigo11,.indigo12,.indigo13,.indigo14,\
.blue1,.blue2,.blue3,.blue4,.blue5,.blue6,.blue7,.blue8,.blue9,.blue10,.blue11,.blue12,.blue13,.blue14,\
.light-blue1,.light-blue2,.light-blue3,.light-blue4,.light-blue5,.light-blue6,.light-blue7,.light-blue8,.light-blue9,.light-blue10,.light-blue11,.light-blue12,.light-blue13,.light-blue14,\
.cyan1,.cyan2,.cyan3,.cyan4,.cyan5,.cyan6,.cyan7,.cyan8,.cyan9,.cyan10,.cyan11,.cyan12,.cyan13,.cyan14,\
.teal1,.teal2,.teal3,.teal4,.teal5,.teal6,.teal7,.teal8,.teal9,.teal10,.teal11,.teal12,.teal13,.teal14,\
.green1,.green2,.green3,.green4,.green5,.green6,.green7,.green8,.green9,.green10,.green11,.green12,.green13,.green14,\
.light-green1,.light-green2,.light-green3,.light-green4,.light-green5,.light-green6,.light-green7,.light-green8,.light-green9,.light-green10,.light-green11,.light-green12,.light-green13,.light-green14,\
.lime1,.lime2,.lime3,.lime4,.lime5,.lime6,.lime7,.lime8,.lime9,.lime10,.lime11,.lime12,.lime13,.lime14,\
.yellow1,.yellow2,.yellow3,.yellow4,.yellow5,.yellow6,.yellow7,.yellow8,.yellow9,.yellow10,.yellow11,.yellow12,.yellow13,.yellow14,\
.amber1,.amber2,.amber3,.amber4,.amber5,.amber6,.amber7,.amber8,.amber9,.amber10,.amber11,.amber12,.amber13,.amber14,\
.orange1,.orange2,.orange3,.orange4,.orange5,.orange6,.orange7,.orange8,.orange9,.orange10,.orange11,.orange12,.orange13,.orange14,\
.deep-orange1,.deep-orange2,.deep-orange3,.deep-orange4,.deep-orange5,.deep-orange6,.deep-orange7,.deep-orange8,.deep-orange9,.deep-orange10,.deep-orange11,.deep-orange12,.deep-orange13,.deep-orange14,\
.brown1,.brown2,.brown3,.brown4,.brown5,.brown6,.brown7,.brown8,.brown9,.brown10,.brown11,.brown12,.brown13,.brown14,.grey1,.grey2,.grey3,.grey4,.grey5,.grey6,.grey7,.grey8,.grey9,.grey10,.grey11,.grey12,.grey13,.grey14,\
.blue-grey1,.blue-grey2,.blue-grey3,.blue-grey4,.blue-grey5,.blue-grey6,.blue-grey7,.blue-grey8,.blue-grey9,.blue-grey10,.blue-grey11,.blue-grey12,.blue-grey13,.blue-grey14"
      ).on("click", function () {
        if ($(".config_chat_head").css("background-color")) {
          $(".config_chat_head").removeAttr("style");
          var backgroundColor = $(this).css("background-color");
          thisController.setState({ color: backgroundColor });

          $(".config_chat_head").css("height", "200px");
        }

        $(".config_chat_head")
          .removeClass(function (index, css) {
            return (css.match(/\bpm_\S+/g) || []).join(" ");
          })
          .addClass(" pm_" + $(this).attr("class"));

        function getBgColorHex(backgroundColor) {
          var color = backgroundColor.css("background-color");
          var hex;
          if (color.indexOf("#") > -1) {
            hex = color;
          } else {
            var rgb = color.match(/\d+/g);
            hex =
              "#" +
              ("0" + parseInt(rgb[0], 10).toString(16)).slice(-2) +
              ("0" + parseInt(rgb[1], 10).toString(16)).slice(-2) +
              ("0" + parseInt(rgb[2], 10).toString(16)).slice(-2);
          }
          return hex;
        }
        var hexColor = getBgColorHex($(this));

        $(".optQ").css("color", hexColor);
        $(".chat_footer svg,.lockpinsvg #Fill-3,.editIcon svg").css({
          fill: hexColor,
        });
        $(".card-footer a.btn_round").css("background-color", hexColor);

        var inputcolor = {
          "border-bottom ": " 1px solid " + hexColor,
          "color ": hexColor,
        };

        $(".login_body input")
          .focus(function () {
            $('label[for="' + this.id + '"]').css({ color: hexColor });
            $(this).css({ "border-bottom": " 2px solid " + hexColor });
          })
          .blur(function () {
            $('label[for="' + this.id + '"]').css({ color: "#9e9e9e" });
            $(this).css({ "border-bottom": " 1px solid #9e9e9e " });
          });

        $("ul.chatoptList li,.optionsBox .optionBtn").css({
          "border-color": hexColor,
        });
      });

      $("#hexinput").change(function () {
        // <-- use change event
        function getBgColorHex(elem) {
          var color = elem.css("background-color");
          var hex;
          if (color.indexOf("#") > -1) {
            //for IE
            hex = color;
          } else {
            var rgb = color.match(/\d+/g);
            hex =
              "#" +
              ("0" + parseInt(rgb[0], 10).toString(16)).slice(-2) +
              ("0" + parseInt(rgb[1], 10).toString(16)).slice(-2) +
              ("0" + parseInt(rgb[2], 10).toString(16)).slice(-2);
          }
          return hex;
        }

        var hexColor = getBgColorHex($(this));

        $(".optQ").css("color", hexColor);
        $(".chat_footer svg,.lockpinsvg #Fill-3 ,.editIcon svg").css({
          fill: hexColor,
        });
        $(".config_chat_head")
          .removeClass(function (index, css) {
            return (css.match(/\bpm_\S+/g) || []).join(" ");
          })
          .css("background-color", hexColor);
        $(".card-footer a.btn_round").css("background-color", hexColor);
        $("ul.chatoptList li,.optionsBox .optionBtn").css({
          "border-color": hexColor,
        });
      });
    })();
  }

  handleChangeColor = ({ target }) => {
    var colorPaletteComponent = this;
    colorPaletteComponent.state.color = target.value;

    var themeColor = target.value;
    if (document.getElementById("hexinput") != null) {
      document.getElementById("hexinput").value = themeColor;
    }

    if (
      document.getElementById("heading") != null &&
      document.getElementById("firstScreenbtn") != null
    ) {
      var widgetColorTimer = setInterval(function () {
        clearTimeout(widgetColorTimer);
        document.getElementById("heading").style.background =
          colorPaletteComponent.state.color;
        document.getElementById("firstScreenbtn").style.background =
          colorPaletteComponent.state.color;
      }, 50);
    }
    colorPaletteComponent.setState(colorPaletteComponent.state);
  };

  notifyInvalidColorCode = () => {
    toast.dismiss();
    toast(
      <b>
        <img
          src="./assets/images/warn.svg"
          style={{ paddingRight: "0px", height: "20px", width: "20px" }}
          content=""
        />
        &nbsp;&nbsp;Please enter valid Color code
      </b>,
      {
        position: "top-center",
      }
    );
  };

  validColorCode(colorCode) {
    var validColorCode = false;
    if (colorCode.startsWith("#")) {
      if (/^#[0-9A-F]{6}$/i.test(colorCode)) {
        validColorCode = true;
      } else {
        validColorCode = false;
      }
    } else if (colorCode.startsWith("rgb")) {
      if (/rgb\((\d{1,3}), (\d{1,3}), (\d{1,3})\)/.test(colorCode)) {
        validColorCode = true;
      } else {
        validColorCode = false;
      }
    } else {
      validColorCode = false;
    }
    return validColorCode;
  }

  handleKeyDown = (e) => {
    if (e.key === "Enter") {
      this.handleChangeColor(e);
    }
  };

  render() {
    return (
      <div>
        <link
          rel="stylesheet"
          type="text/css"
          href="plugins/font-awesome/css/font-awesome.min.css"
        />

        <link
          rel="stylesheet"
          type="text/css"
          href="https://fonts.googleapis.com/icon?family=Material+Icons"
        />
        <link
          rel="stylesheet"
          type="text/css"
          href="assets/fonts/flat-icon/flaticon.css"
        />

        <link rel="stylesheet" type="text/css" href="dist/css/adminlte.css" />
        <link
          rel="stylesheet"
          type="text/css"
          href="assets/css/custom-style.css"
        />
        <link href="assets/css/styles.css" type="text/css" rel="stylesheet" />
        <link rel="stylesheet" type="text/css" href="assets/css/mediaQ.css" />
        <link
          rel="stylesheet"
          type="text/css"
          href="https://fonts.googleapis.com/icon?family=Material+Icons"
        />
        {/* Font Awesome Icons */}
        <link
          rel="stylesheet"
          type="text/css"
          href="plugins/font-awesome/css/font-awesome.min.css"
        />
        {/* IonIcons */}
        <link
          rel="stylesheet"
          type="text/css"
          href="//code.ionicframework.com/ionicons/2.0.1/css/ionicons.min.css"
        />
        <link
          rel="stylesheet"
          type="text/css"
          href="assets/fonts/flat-icon/flaticon.css"
        />
        {/* Select2 */}
        <link
          rel="stylesheet"
          type="text/css"
          href="plugins/select2/select2.min.css"
        />
        {/* Theme style */}
        <link rel="stylesheet" type="text/css" href="assets/css/adminlte.css" />
        <link rel="stylesheet" type="text/css" href="assets/css/styles.css" />
        <link
          rel="stylesheet"
          type="text/css"
          href="assets/css/custom-style.css"
        />
        <link
          rel="stylesheet"
          type="text/css"
          href="assets/css/configBot.css"
        />
        <link rel="stylesheet" type="text/css" href="assets/css/mediaQ.css" />
        <div className="card-body ">
          <div className="tab-content col-12 p-0">
            <div className="tab-pane nav-link active show">
              <div className="card-primary mt-2">
                <ToastContainer className="Toast-at-center" />

                <div className="p-2" align="right">
                  <button
                    type="button"
                    className="btn action-button"
                    title="save color"
                    onClick={this.saveData}
                  >
                    {" "}
                    <img
                      className="img-responsive cursor-change"
                      src="./assets/images/baseline_save_white_24dp.png"
                    />
                  </button>
                  <button
                    type="button"
                    className="btn action-button"
                    title="refresh"
                    onClick={this.refreshColor}
                  >
                    {" "}
                    <img
                      className="img-responsive cursor-change"
                      src="./assets/images/refresh_white_24dp.png"
                    />
                  </button>
                </div>

                {this.state.widgetSkinTypes && (
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "38px",
                    }}
                  >
                    <label htmlFor="selectWidgetSkinType">
                      Widget skin type:{" "}
                    </label>
                    <select
                      value={this.state.widgetSkinType}
                      id="selectWidgetSkinType"
                      className="input-group mb-3 form-control select2"
                      style={{
                        width: "12rem",
                        height: "30px",
                        borderRadius: "4px",
                        backgroundColor: "#F9F9FB",
                      }}
                      onChange={({ target }) => {
                        console.log(target.value);
                        this.setState({ widgetSkinType: target.value });
                      }}
                    >
                      {Object.keys(this.state.widgetSkinTypes).map((key) => {
                        const value = this.state.widgetSkinTypes[key];
                        return (
                          <option value={key} key={key}>
                            {value}
                          </option>
                        );
                      })}
                    </select>
                  </div>
                )}

                <div className="hexcodeBox">
                  <label htmlFor="hexinput" className="m-0">
                    Color Code :{" "}
                  </label>
                  <p style={{ display: "inline-block" }} className="m-0">
                    <input
                      id="hexinput"
                      type="text"
                      value={this.state.color}
                      data-wheelcolorpicker
                      data-wcp-sliders="wsvp"
                      data-wcp-format="css"
                      data-wcp-cssclassname="color-block"
                      data-wcp-autoresize={false}
                      data-wcp-preview={true}
                      onBlur={this.handleChangeColor}
                      onKeyDown={this.handleKeyDown}
                      onChange={this.handleChangeColor}
                    />
                  </p>

                  <p />
                </div>
                <div className="color-box ">
                  <ul className="color-palette">
                    <li id="colorBlock" className="color-txt">
                      Red
                    </li>
                    <li id="colorBlock" className="red1" />
                    <li id="colorBlock" className="red2" />
                    <li id="colorBlock" className="red3" />
                    <li id="colorBlock" className="red4" />
                    <li id="colorBlock" className="red5" />
                    <li id="colorBlock" className="red6" />
                    <li id="colorBlock" className="red7" />
                    <li id="colorBlock" className="red8" />
                    <li id="colorBlock" className="red9" />
                    <li id="colorBlock" className="red10" />
                    <li id="colorBlock" className="red11" />
                    <li id="colorBlock" className="red12" />
                    <li id="colorBlock" className="red13" />
                    <li id="colorBlock" className="red14" />
                  </ul>
                  <ul className="color-palette">
                    <li id="colorBlock" className="color-txt">
                      Pink
                    </li>
                    <li id="colorBlock" className="pink1" />
                    <li id="colorBlock" className="pink2" />
                    <li id="colorBlock" className="pink3" />
                    <li id="colorBlock" className="pink4" />
                    <li id="colorBlock" className="pink5" />
                    <li id="colorBlock" className="pink6" />
                    <li id="colorBlock" className="pink7" />
                    <li id="colorBlock" className="pink8" />
                    <li id="colorBlock" className="pink9" />
                    <li id="colorBlock" className="pink10" />
                    <li id="colorBlock" className="pink11" />
                    <li id="colorBlock" className="pink12" />
                    <li id="colorBlock" className="pink13" />
                    <li id="colorBlock" className="pink14" />
                  </ul>
                  <ul className="color-palette">
                    <li id="colorBlock" className="color-txt">
                      Purple
                    </li>
                    <li id="colorBlock" className="purple1" />
                    <li id="colorBlock" className="purple2" />
                    <li id="colorBlock" className="purple3" />
                    <li id="colorBlock" className="purple4" />
                    <li id="colorBlock" className="purple5" />
                    <li id="colorBlock" className="purple6" />
                    <li id="colorBlock" className="purple7" />
                    <li id="colorBlock" className="purple8" />
                    <li id="colorBlock" className="purple9" />
                    <li id="colorBlock" className="purple10" />
                    <li id="colorBlock" className="purple11" />
                    <li id="colorBlock" className="purple12" />
                    <li id="colorBlock" className="purple13" />
                    <li id="colorBlock" className="purple14" />
                  </ul>
                  <ul className="color-palette">
                    <li id="colorBlock" className="color-txt">
                      Deep-Purple
                    </li>
                    <li id="colorBlock" className="deep-purple1" />
                    <li id="colorBlock" className="deep-purple2" />
                    <li id="colorBlock" className="deep-purple3" />
                    <li id="colorBlock" className="deep-purple4" />
                    <li id="colorBlock" className="deep-purple5" />
                    <li id="colorBlock" className="deep-purple6" />
                    <li id="colorBlock" className="deep-purple7" />
                    <li id="colorBlock" className="deep-purple8" />
                    <li id="colorBlock" className="deep-purple9" />
                    <li id="colorBlock" className="deep-purple10" />
                    <li id="colorBlock" className="deep-purple11" />
                    <li id="colorBlock" className="deep-purple12" />
                    <li id="colorBlock" className="deep-purple13" />
                    <li id="colorBlock" className="deep-purple14" />
                  </ul>
                  <ul className="color-palette">
                    <li id="colorBlock" className="color-txt">
                      Indigo
                    </li>
                    <li id="colorBlock" className="indigo1" />
                    <li id="colorBlock" className="indigo2" />
                    <li id="colorBlock" className="indigo3" />
                    <li id="colorBlock" className="indigo4" />
                    <li id="colorBlock" className="indigo5" />
                    <li id="colorBlock" className="indigo6" />
                    <li id="colorBlock" className="indigo7" />
                    <li id="colorBlock" className="indigo8" />
                    <li id="colorBlock" className="indigo9" />
                    <li id="colorBlock" className="indigo10" />
                    <li id="colorBlock" className="indigo11" />
                    <li id="colorBlock" className="indigo12" />
                    <li id="colorBlock" className="indigo13" />
                    <li id="colorBlock" className="indigo14" />
                  </ul>
                  <ul className="color-palette">
                    <li id="colorBlock" className="color-txt">
                      Blue
                    </li>
                    <li id="colorBlock" className="blue1" />
                    <li id="colorBlock" className="blue2" />
                    <li id="colorBlock" className="blue3" />
                    <li id="colorBlock" className="blue4" />
                    <li id="colorBlock" className="blue5" />
                    <li id="colorBlock" className="blue6" />
                    <li id="colorBlock" className="blue7" />
                    <li id="colorBlock" className="blue8" />
                    <li id="colorBlock" className="blue9" />
                    <li id="colorBlock" className="blue10" />
                    <li id="colorBlock" className="blue11" />
                    <li id="colorBlock" className="blue12" />
                    <li id="colorBlock" className="blue13" />
                    <li id="colorBlock" className="blue14" />
                  </ul>
                  <ul className="color-palette">
                    <li id="colorBlock" className="color-txt">
                      Light Blue
                    </li>
                    <li id="colorBlock" className="light-blue1" />
                    <li id="colorBlock" className="light-blue2" />
                    <li id="colorBlock" className="light-blue3" />
                    <li id="colorBlock" className="light-blue4" />
                    <li id="colorBlock" className="light-blue5" />
                    <li id="colorBlock" className="light-blue6" />
                    <li id="colorBlock" className="light-blue7" />
                    <li id="colorBlock" className="light-blue8" />
                    <li id="colorBlock" className="light-blue9" />
                    <li id="colorBlock" className="light-blue10" />
                    <li id="colorBlock" className="light-blue11" />
                    <li id="colorBlock" className="light-blue12" />
                    <li id="colorBlock" className="light-blue13" />
                    <li id="colorBlock" className="light-blue14" />
                  </ul>
                  <ul className="color-palette">
                    <li id="colorBlock" className="color-txt">
                      Cyan
                    </li>
                    <li id="colorBlock" className="cyan1" />
                    <li id="colorBlock" className="cyan2" />
                    <li id="colorBlock" className="cyan3" />
                    <li id="colorBlock" className="cyan4" />
                    <li id="colorBlock" className="cyan5" />
                    <li id="colorBlock" className="cyan6" />
                    <li id="colorBlock" className="cyan7" />
                    <li id="colorBlock" className="cyan8" />
                    <li id="colorBlock" className="cyan9" />
                    <li id="colorBlock" className="cyan10" />
                    <li id="colorBlock" className="cyan11" />
                    <li id="colorBlock" className="cyan12" />
                    <li id="colorBlock" className="cyan13" />
                    <li id="colorBlock" className="cyan14" />
                  </ul>
                  <ul className="color-palette">
                    <li id="colorBlock" className="color-txt">
                      Teal
                    </li>
                    <li id="colorBlock" className="teal1" />
                    <li id="colorBlock" className="teal2" />
                    <li id="colorBlock" className="teal3" />
                    <li id="colorBlock" className="teal4" />
                    <li id="colorBlock" className="teal5" />
                    <li id="colorBlock" className="teal6" />
                    <li id="colorBlock" className="teal7" />
                    <li id="colorBlock" className="teal8" />
                    <li id="colorBlock" className="teal9" />
                    <li id="colorBlock" className="teal10" />
                    <li id="colorBlock" className="teal11" />
                    <li id="colorBlock" className="teal12" />
                    <li id="colorBlock" className="teal13" />
                    <li id="colorBlock" className="teal14" />
                  </ul>
                  <ul className="color-palette">
                    <li id="colorBlock" className="color-txt">
                      Green
                    </li>
                    <li id="colorBlock" className="green1" />
                    <li id="colorBlock" className="green2" />
                    <li id="colorBlock" className="green3" />
                    <li id="colorBlock" className="green4" />
                    <li id="colorBlock" className="green5" />
                    <li id="colorBlock" className="green6" />
                    <li id="colorBlock" className="green7" />
                    <li id="colorBlock" className="green8" />
                    <li id="colorBlock" className="green9" />
                    <li id="colorBlock" className="green10" />
                    <li id="colorBlock" className="green11" />
                    <li id="colorBlock" className="green12" />
                    <li id="colorBlock" className="green13" />
                    <li id="colorBlock" className="green14" />
                  </ul>
                  <ul className="color-palette">
                    <li id="colorBlock" className="color-txt">
                      Light Green
                    </li>
                    <li id="colorBlock" className="light-green1" />
                    <li id="colorBlock" className="light-green2" />
                    <li id="colorBlock" className="light-green3" />
                    <li id="colorBlock" className="light-green4" />
                    <li id="colorBlock" className="light-green5" />
                    <li id="colorBlock" className="light-green6" />
                    <li id="colorBlock" className="light-green7" />
                    <li id="colorBlock" className="light-green8" />
                    <li id="colorBlock" className="light-green9" />
                    <li id="colorBlock" className="light-green10" />
                    <li id="colorBlock" className="light-green11" />
                    <li id="colorBlock" className="light-green12" />
                    <li id="colorBlock" className="light-green13" />
                    <li id="colorBlock" className="light-green14" />
                  </ul>
                  <ul className="color-palette">
                    <li id="colorBlock" className="color-txt">
                      Lime
                    </li>
                    <li id="colorBlock" className="lime1" />
                    <li id="colorBlock" className="lime2" />
                    <li id="colorBlock" className="lime3" />
                    <li id="colorBlock" className="lime4" />
                    <li id="colorBlock" className="lime5" />
                    <li id="colorBlock" className="lime6" />
                    <li id="colorBlock" className="lime7" />
                    <li id="colorBlock" className="lime8" />
                    <li id="colorBlock" className="lime9" />
                    <li id="colorBlock" className="lime10" />
                    <li id="colorBlock" className="lime11" />
                    <li id="colorBlock" className="lime12" />
                    <li id="colorBlock" className="lime13" />
                    <li id="colorBlock" className="lime14" />
                  </ul>
                  <ul className="color-palette">
                    <li id="colorBlock" className="color-txt">
                      Yellow
                    </li>
                    <li id="colorBlock" className="yellow1" />
                    <li id="colorBlock" className="yellow2" />
                    <li id="colorBlock" className="yellow3" />
                    <li id="colorBlock" className="yellow4" />
                    <li id="colorBlock" className="yellow5" />
                    <li id="colorBlock" className="yellow6" />
                    <li id="colorBlock" className="yellow7" />
                    <li id="colorBlock" className="yellow8" />
                    <li id="colorBlock" className="yellow9" />
                    <li id="colorBlock" className="yellow10" />
                    <li id="colorBlock" className="yellow11" />
                    <li id="colorBlock" className="yellow12" />
                    <li id="colorBlock" className="yellow13" />
                    <li id="colorBlock" className="yellow14" />
                  </ul>
                  <ul className="color-palette">
                    <li id="colorBlock" className="color-txt">
                      Amber
                    </li>
                    <li id="colorBlock" className="amber1" />
                    <li id="colorBlock" className="amber2" />
                    <li id="colorBlock" className="amber3" />
                    <li id="colorBlock" className="amber4" />
                    <li id="colorBlock" className="amber5" />
                    <li id="colorBlock" className="amber6" />
                    <li id="colorBlock" className="amber7" />
                    <li id="colorBlock" className="amber8" />
                    <li id="colorBlock" className="amber9" />
                    <li id="colorBlock" className="amber10" />
                    <li id="colorBlock" className="amber11" />
                    <li id="colorBlock" className="amber12" />
                    <li id="colorBlock" className="amber13" />
                    <li id="colorBlock" className="amber14" />
                  </ul>
                  <ul className="color-palette">
                    <li id="colorBlock" className="color-txt">
                      Orange
                    </li>
                    <li id="colorBlock" className="orange1" />
                    <li id="colorBlock" className="orange2" />
                    <li id="colorBlock" className="orange3" />
                    <li id="colorBlock" className="orange4" />
                    <li id="colorBlock" className="orange5" />
                    <li id="colorBlock" className="orange6" />
                    <li id="colorBlock" className="orange7" />
                    <li id="colorBlock" className="orange8" />
                    <li id="colorBlock" className="orange9" />
                    <li id="colorBlock" className="orange10" />
                    <li id="colorBlock" className="orange11" />
                    <li id="colorBlock" className="orange12" />
                    <li id="colorBlock" className="orange13" />
                    <li id="colorBlock" className="orange14" />
                  </ul>
                  <ul className="color-palette">
                    <li id="colorBlock" className="color-txt">
                      Deep Orange
                    </li>
                    <li id="colorBlock" className="deep-orange1" />
                    <li id="colorBlock" className="deep-orange2" />
                    <li id="colorBlock" className="deep-orange3" />
                    <li id="colorBlock" className="deep-orange4" />
                    <li id="colorBlock" className="deep-orange5" />
                    <li id="colorBlock" className="deep-orange6" />
                    <li id="colorBlock" className="deep-orange7" />
                    <li id="colorBlock" className="deep-orange8" />
                    <li id="colorBlock" className="deep-orange9" />
                    <li id="colorBlock" className="deep-orange10" />
                    <li id="colorBlock" className="deep-orange11" />
                    <li id="colorBlock" className="deep-orange12" />
                    <li id="colorBlock" className="deep-orange13" />
                    <li id="colorBlock" className="deep-orange14" />
                  </ul>
                  <ul className="color-palette">
                    <li id="colorBlock" className="color-txt">
                      Brown
                    </li>
                    <li id="colorBlock" className="brown1"></li>
                    <li id="colorBlock" className="brown2"></li>
                    <li id="colorBlock" className="brown3"></li>
                    <li id="colorBlock" className="brown4"></li>
                    <li id="colorBlock" className="brown5"></li>
                    <li id="colorBlock" className="brown6"></li>
                    <li id="colorBlock" className="brown7"></li>
                    <li id="colorBlock" className="brown8"></li>
                    <li id="colorBlock" className="brown9"></li>
                    <li id="colorBlock" className="brown10"></li>
                    <li id="colorBlock" className="brown11"></li>
                    <li id="colorBlock" className="brown12"></li>
                    <li id="colorBlock" className="brown13"></li>
                    <li id="colorBlock" className="brown14"></li>
                  </ul>
                  <ul className="color-palette">
                    <li id="colorBlock" className="color-txt">
                      Grey
                    </li>
                    <li id="colorBlock" className="grey1"></li>
                    <li id="colorBlock" className="grey2"></li>
                    <li id="colorBlock" className="grey3"></li>
                    <li id="colorBlock" className="grey4"></li>
                    <li id="colorBlock" className="grey5"></li>
                    <li id="colorBlock" className="grey6"></li>
                    <li id="colorBlock" className="grey7"></li>
                    <li id="colorBlock" className="grey8"></li>
                    <li id="colorBlock" className="grey9"></li>
                    <li id="colorBlock" className="grey10"></li>
                    <li id="colorBlock" className="grey11"></li>
                    <li id="colorBlock" className="grey12"></li>
                    <li id="colorBlock" className="grey13"></li>
                    <li id="colorBlock" className="grey14"></li>
                  </ul>
                  <ul className="color-palette">
                    <li id="colorBlock" className="color-txt">
                      Blue Grey
                    </li>
                    <li id="colorBlock" className="blue-grey1"></li>
                    <li id="colorBlock" className="blue-grey2"></li>
                    <li id="colorBlock" className="blue-grey3"></li>
                    <li id="colorBlock" className="blue-grey4"></li>
                    <li id="colorBlock" className="blue-grey5"></li>
                    <li id="colorBlock" className="blue-grey6"></li>
                    <li id="colorBlock" className="blue-grey7"></li>
                    <li id="colorBlock" className="blue-grey8"></li>
                    <li id="colorBlock" className="blue-grey9"></li>
                    <li id="colorBlock" className="blue-grey10"></li>
                    <li id="colorBlock" className="blue-grey11"></li>
                    <li id="colorBlock" className="blue-grey12"></li>
                    <li id="colorBlock" className="blue-grey13"></li>
                    <li id="colorBlock" className="blue-grey14"></li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default ColorPlatte;



// WEBPACK FOOTER //
// ./src/projectmgmt/settings/ColorPlatte.js